import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=4e5abd8b&scoped=true&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./contact.vue?vue&type=style&index=0&id=4e5abd8b&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4e5abd8b",
  "d7752540"
  
)

export default component.exports